import './assets/base.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@/libraries/fontawesome'

// Datatables
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'

// Swiper
import { register } from 'swiper/element/bundle'
register()

import App from './App.vue'
import router from './router'

// Layout Imports
import AppNavbar from './components/layout/navbar/AppNavbar.vue'
import AppSidebar from './components/layout/sidebar/AppSidebar.vue'
import AppTitleBar from './components/layout/titlebar/AppTitleBar.vue'
import AppPanel from './components/layout/panel/AppPanel.vue'
import AppScrollContainer from './components/layout/core/AppScrollContainer.vue'

// Base Imports
import AppAlert from './components/base/AppAlert.vue'
import AppButton from './components/base/AppButton.vue'
import AppBadge from './components/base/AppBadge.vue'
import AppDropdown from './components/base/AppDropdown.vue'
import AppLoader from './components/base/AppLoader.vue'
import AppTooltip from './components/base/AppTooltip.vue'
import AppIcon from './components/base/AppIcon.vue'
import AppLabel from './components/base/forms/AppLabel.vue'
import AppInput from './components/base/forms/AppInput.vue'
import AppSelect from './components/base/forms/AppSelect.vue'
import AppCheckbox from './components/base/forms/AppCheckbox.vue'
import AppFileButton from './components/base/forms/AppFileButton.vue'
import AppRadioGroup from './components/base/forms/AppRadioGroup.vue'

// Loaders
import TextSkeleton from './components/loaders/TextSkeleton.vue'

// Partials
import Slideover from './components/partials/Slideover.vue'
import ListGroup from './components/partials/ListGroup.vue'
import Tabs from './components/partials/Tabs.vue'
import ConfirmDialog from './components/partials/dialogs/Confirm.vue'
import ContractNotes from './components/partials/dialogs/ContractNotes.vue'
import Toaster from './components/partials/Toaster.vue'
import TouchButton from './components/partials/yard-app/TouchButton.vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import ExpandRows from '@/components/partials/tables/ExpandRows.vue'
import Datatable from '@/components/partials/Datatable.vue'
import { definePreset } from '@primevue/themes'

const app = createApp(App)

// Third party
app.component('FontAwesomeIcon', FontAwesomeIcon)
app.component('VueDatePicker', VueDatePicker)

// Layout
app.component('AppNavbar', AppNavbar)
app.component('AppSidebar', AppSidebar)
app.component('AppTitleBar', AppTitleBar)
app.component('AppPanel', AppPanel)

// Base
app.component('AppAlert', AppAlert)
app.component('AppButton', AppButton)
app.component('AppBadge', AppBadge)
app.component('AppDropdown', AppDropdown)
app.component('AppLoader', AppLoader)
app.component('AppTooltip', AppTooltip)
app.component('AppScrollContainer', AppScrollContainer)
app.component('AppIcon', AppIcon)

// Loaders
app.component('TextSkeleton', TextSkeleton)

// Forms
app.component('AppLabel', AppLabel)
app.component('AppInput', AppInput)
app.component('AppSelect', AppSelect)
app.component('AppCheckbox', AppCheckbox)
app.component('AppFileButton', AppFileButton)
app.component('AppRadioGroup', AppRadioGroup)

// Partials
app.component('Slideover', Slideover)
app.component('ListGroup', ListGroup)
app.component('AppTabs', Tabs)
app.component('ConfirmDialog', ConfirmDialog)
app.component('ContractNotes', ContractNotes)
app.component('Toaster', Toaster)
app.component('TouchButton', TouchButton)
app.component('ExpandRows', ExpandRows)
app.component('Datatable', Datatable)

app.use(createPinia())
app.use(router)

const Theme = definePreset(Aura, {
	semantic: {
		primary: {
			50: '{blue.50}',
			100: '{blue.100}',
			200: '{blue.200}',
			300: '{blue.300}',
			400: '{blue.400}',
			500: '{blue.500}',
			600: '{blue.600}',
			700: '{blue.700}',
			800: '{blue.800}',
			900: '{blue.900}',
			950: '{blue.950}'
		}
	}
})

app.use(PrimeVue, {
	theme: {
		preset: Theme,
		options: {
			darkModeSelector: false,
			cssLayer: {
				name: 'primevue',
				order: 'tailwind-base, primevue, tailwind-utilities'
			}
		}
	}
})

app.mount('#app')
